import { mountVueComponent } from '@/lib/mount-vue-component';

export default function() {
  import('@/modules/clear/component/PasswordResetForm.vue').then(PasswordResetForm => {
    mountVueComponent('password-reset-form', PasswordResetForm, true);
  });
}
